import { PageLayout } from 'src/legacy/components/Layout';
import Layout from 'src/legacy/components/Layout/Layout';
import { PaymentLinkPay } from 'src/routes/billing/payment-links/pay/page';
import { RouteAction } from 'src/routes/types';

const action: RouteAction = () => {
  return {
    chunks: ['payment-links-pay'],
    title: 'Pay Payment Link',
    component: (
      <Layout
        title="Pay Payment Link"
        disableGutters
        hasSidebar={false}
        hasNavbar={false}
      >
        <PageLayout
          fullpage
          routeAccessCheck="allowClientPaymentLinks"
          unauthAccessAllowed="allowClientPaymentLinks"
        >
          <PaymentLinkPay />
        </PageLayout>
      </Layout>
    ),
  };
};

export default action;
